//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

const slugify = require('speakingurl');

export default {
  name: 'MarketLine',
  props: ['market', 'event', 'sport', 'filter', 'competition', 'cols', 'loading'],
  data() {
    return {
      balance: null
    }
  },
  computed: {
    isEnabled() {
      if (_.get(this.event, 'status') === 'live' && _.get(this.event, 'liveodds') !== 'booked') {
        return false
      }
      return true
    }
  },
  filters: {

  },
  mounted() {},
  methods: {
    getURL: function (event, competition) {
      if (_.get(competition, 'sport.category') === 'esport') {
        return this.localePath({ name:'e-sports-match-id', params: {id: event.id}})
      }
      if (_.get(competition, 'sport.category') === 'virtual') {
        return this.localePath({ name: 'virtual-slug', params: {
          id: event.id,
          slug: _.get(event, 'translated_sport_slug'),
        }, query: {
          event_id: event.id,
        }
        
        })
      }

      return this.localePath({ name: 'match-screen', params: {
        sport: _.get(event, 'translated_sport_slug'),
        slug: slugify(event.name) + '-' + this.getEventId(event.id),
        competition: _.get(event, 'translated_competition_slug'),
      }})

    },
    openStats() {
      this.$store.commit('setStatId', this.event.id)
      this.$modal.show('modal-stats');
    }
  }
}
